import InvoiceDetails from '@/modules/billing/pages/InvoiceDetails';

export default InvoiceDetails;
